import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
//import Categories from "./pages/";
import Contact from "./pages/Contact";
import CategoryDetail from "./pages/CategoryDetail";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <div className="App">
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              {/*  <Route path="/about" element={<About />} /> */}
              {/*  <Route path="/categories" element={<Categories />} /> */}
              <Route
                path="/category/:categoryId"
                element={<CategoryDetail />}
              />
              {/* <Route path="/contact" element={<Contact />} /> */}
            </Routes>
          </main>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
